import {
  RulebookViewModel,
  RuleTypeName,
  RulebookModel,
} from '../../models/rulebook';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserProfile } from '../../models/user';
import { FileType } from './../../enums/user/file-type';
import { Role } from '../../models/user-management/role';
import { Policies } from './../../models/rulebook/policies';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ItemInfoDto } from '../../models/rulebook/item.info-dto';
import { environment } from '../../../../environments/environment';
import { KeywordDataList } from '../../models/rulebook/keyword-item';
import { KeywordModal } from './../../models/rulebook/keyword-modal';
import { DateRangeModel } from '../../models/rulebook/date-range-model';
import { SelfAssessment } from '../../models/self-assessment/self-assessment';
import { RegulationViewModel, RegulationModel } from '../../models/regulation';
import { CompareItemModel } from '../../models/filter-model/compare-item-model';
import { RuleTreeDataModel } from './../../models/rulebook/rule-tree-data-model';
import { RulebookFilterModel } from '../../models/rulebook/rulebook-filters-model';
import { RulebookMasterFilter } from '../../models/rulebook/rulebook-master-filter';
import { VersionHistoryViewModel } from './../../models/self-assessment/version-history';
import { VersionHistoryFilter } from '../../models/self-assessment/version-history-filter';
import { LinkedUpdateFilterModel } from '../../models/rulebook/linked-update-filter-model';
import { SelfAssessmentFilter } from '../../models/self-assessment/self-assessment-filter';
import { RuleAnalytic, RuleAnalyticData } from '../../models/rulebook/rule-analytic-data-model';
import { SelfAssessmentT2ViewModel, SelfAssessmentViewModel } from '../../models/self-assessment/self-assessment-view-model';
import { SelfAssessmentAllDropdownList, SelfAssessmentDetailsDD, SelfAssessmentT2AllDropdownList, SelfAssessmentT2DetailsDD } from '../../models/self-assessment/self-assessment-details-dd';
import { SelfAssessmentGapModel, SelfAssessmentT2GapModel } from './../../models/self-assessment/self-assessment-gap-model';
import { SelfAssessmentMasterFilter } from '../../models/self-assessment/self-assessment-master-filter';
import { SelfAssessmentEnhancementModel, SelfAssessmentT2EnhancementModel } from '../../models/self-assessment/self-assessment-enhancement';
import { SelfAssessmentDocumentModel } from '../../models/self-assessment/self-assessment-document-model';
import { SelfAssessmentDetailHistory, SelfAssessmentT2DetailHistory } from '../../models/self-assessment/self-assessment-detail-history';
import { UpdateSelfAssessmentModel } from 'src/app/core/models/self-assessment/update-self-assessment-model';
import { BulkInsertModel } from '../../models/impact-assessment/bulk-insert-model';
import { LibraryType, RulebookLibraryMenu } from '../../models/rulebook/rulebook-library-menu';
import { setSummaryDetails } from '../../models/rulebook/rulebook.model';
import { RulebookSummary } from '../../models/rulebook/rulebook-summary';
import { ReportingTemplate } from '../../models/rulebook/reporting-template-model';
import { ReprtingTemplateList } from '../../models/reporting/reporting-template-list';
import { Controls } from '../../models/rulebook/controls';
import { LinkedControlData } from '../../models/rulebook/linked-control-data-model';
import { ControlDocument } from '../../models/rulebook/control-document';
import { SelfAssessmentVersionModel } from '../../models/self-assessment/self-assessment-version-model';
import { BulkSelfUpdateModel, BulkSelfUpdateModelT2 } from '../../models/self-assessment/bulk-self-update-model';
import { RegulationCheckboxReturnModel } from '../../models/regulation/regulation-checkbox-view-model';
import { BulkCheckBoxRule, BulkUpdateRule } from '../../models/rulebook/bulk-update-rule';
import { MergeAssess } from '../../models/regulation/merge-assess-model';
import { SelfAssessmentNew, SelfAssessmentT2 } from '../../models/self-assessmentT2/self-assessmentT2';
import { SelfAssessmentCkDataSaveModel, UpdateSelfAssessmentT2Model } from '../../models/self-assessmentT2/update-self-assessmentT2-model';
import { SelfAssessmentT2VersionModel } from '../../models/self-assessmentT2/self-assessmentT2-version-model';
import { SelfAssessmentT2Filter } from '../../models/self-assessmentT2/seld-assessmentT2-filter';
import { SelfAssessmentT2MasterFilter } from '../../models/self-assessmentT2/self-assessmentT2-master-filter';
import { updateRulebookModel } from '../../models/rulebook/updateRulebookDescription';
import { translateOthersToEnglishInputModel } from '../../models/translate/translateInputModel';
@Injectable({ providedIn: 'root' })
export class GDPRService {

  loggedInUser: UserProfile | undefined;
  tabActive = false;
  isShowRuleTree = false;
  ruleTree = '';

  constructor(
    private http: HttpClient
  ) {
  }

  getFirstRulebook(ruleType: RuleTypeName | null): Observable<RulebookModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(ruleType));
    // tslint:disable-next-line:max-line-length
    return this.http.get<RulebookModel>(`${environment.config.baseAppURL}/GDPR/GetFirstRulebook`, { headers });
  }

  getRulebooks(filter: RulebookFilterModel | null): Observable<RulebookViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));

    // tslint:disable-next-line:max-line-length
    return this.http.get<RulebookViewModel>(`${environment.config.baseAppURL}/GDPR/GetRulebooks`, { headers });
  }

  getRulebookById(rulebookId: number): Observable<RegulationModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(rulebookId));
    // tslint:disable-next-line:max-line-length
    return this.http.get<RegulationModel>(`${environment.config.baseAppURL}/GDPR/GetRulebookByIdForDetail`, { headers });
  }

  getRulebookFiltersData(libraryName: string, rulebook: string): Observable<RulebookMasterFilter> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', libraryName + ';' + rulebook);
    // tslint:disable-next-line:max-line-length
    return this.http.get<RulebookMasterFilter>(`${environment.config.baseAppURL}/GDPR/GetRulebookFiltersData`, { headers });
  }

  saveRulebook(rulebookDto: ItemInfoDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/AddNewRulebook`, rulebookDto, { headers });
  }

  removeRulebook(rulebookDto: ItemInfoDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(rulebookDto));
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/DeleteRulebook`, { headers });
  }

  updateRulebook(rulebookDto: ItemInfoDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/UpdateRulebooks`, rulebookDto, { headers });
  }

  saveChildRow(rulebookDto: ItemInfoDto): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<string>(`${environment.config.baseAppURL}/GDPR/AddChildRow`, rulebookDto, { headers });
  }

  addSelfAssessment(itemInfoDto: ItemInfoDto, divisionId: number): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<string>(`${environment.config.baseAppURL}/GDPR/AddSelfAssessment?divisionId=` + divisionId, itemInfoDto, { headers });
  }

  getSelfAssessment(filter: SelfAssessmentFilter): Observable<SelfAssessmentViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    return this.http.get<SelfAssessmentViewModel>(`${environment.config.baseAppURL}/GDPR/GetSelfAssessment`, { headers });
  }

  deleteSelfAssessment(deletedItems: number[], templateNo: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(deletedItems));
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/DeleteSelfAssessment?templateNo=` + templateNo, { headers });
  }

  getSelfAssessmentGaps(filter: SelfAssessmentFilter): Observable<SelfAssessmentGapModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentGapModel>(`${environment.config.baseAppURL}/GDPR/GetSelfAssessmentGaps`, { headers });
  }

  getSelfAssessmentEnhancements(filter: SelfAssessmentFilter): Observable<SelfAssessmentEnhancementModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentEnhancementModel>(`${environment.config.baseAppURL}/GDPR/GetSelfAssessmentEnhancements`, { headers });
  }

  getSelfAssessmentDetails(id: number): Observable<SelfAssessment> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessment>(`${environment.config.baseAppURL}/GDPR/GetSelfAssessmentDetails?id=` + id, { headers });
  }
  getSelfAssessmentVersionDetails(id: number): Observable<SelfAssessmentVersionModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentVersionModel>(`${environment.config.baseAppURL}/GDPR/GetSelfAssessmentVersionDetails?id=` + id, { headers });
  }

  getSelfAssessmentDD(): Observable<SelfAssessmentDetailsDD> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentDetailsDD>(`${environment.config.baseAppURL}/GDPR/GetSelfAssessmentDD`, { headers });
  }

  updateSelfAssessment(selfAssessment: UpdateSelfAssessmentModel, url: string): Observable<SelfAssessment> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', url);
    // tslint:disable-next-line:max-line-length
    return this.http.post<SelfAssessment>(`${environment.config.baseAppURL}/GDPR/UpdateSelfAssessment`, selfAssessment, { headers });
  }

  deleteSelfAssessmentGap(deletedItems: number[], templateNo: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(deletedItems));
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/DeleteSelfAssessmentGap?templateNo=` + templateNo, { headers });
  }

  deleteSelfAssessmentEnhancement(deletedItems: number[], templateNo: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(deletedItems));
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/DeleteSelfAssessmentEnhancement?templateNo=` + templateNo, { headers });
  }

  getVersionHistory(filter: VersionHistoryFilter): Observable<VersionHistoryViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<VersionHistoryViewModel>(`${environment.config.baseAppURL}/GDPR/GetVersionHistory`, { headers });
  }

  uploadEvidence(fileToUpload: File, fileType: FileType, assessmentId: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', fileType.toString() + ';' + assessmentId.toString());
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/UploadEvidenceFile`, formData, { headers });
  }

  downloadEvidence(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', id.toString());
    return this.http.get(`${environment.config.baseAppURL}/GDPR/DownloadEvidence`, { headers, responseType: 'blob' });
  }

  getSelfAssessmentDocuments(id: number): Observable<Array<SelfAssessmentDocumentModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<SelfAssessmentDocumentModel>>(`${environment.config.baseAppURL}/GDPR/GetSelfAssessmentDocument?id=` + id, { headers });
  }

  deleteSelfAssessmentDocument(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/DeleteSelfAssessmentDocument?id=` + id, { headers });
  }

  getSelfAssessmentMasterFilters(): Observable<SelfAssessmentMasterFilter> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<SelfAssessmentMasterFilter>(`${environment.config.baseAppURL}/GDPR/GetSelfAssessmentMasterFilters`, { headers });
  }

  downloadSAReport(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get(`${environment.config.baseAppURL}/GDPR/DownloadReport`, { headers, responseType: 'blob' });
  }

  moveToImpactAssessment(itemInfoDto: ItemInfoDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/MoveToImpactAssessment`, itemInfoDto, { headers });
  }
  getTemplateNo(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/GetTemplateNo`, { headers });
  }

  mergeAndImpactAssessment(itemInfoDto: ItemInfoDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/MergeAndImpactAssessment`, itemInfoDto, { headers });
  }

  GetSADetailsHistory(id: number): Observable<SelfAssessmentDetailHistory> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentDetailHistory>(`${environment.config.baseAppURL}/GDPR/GetSADetailsHistory?id=` + id, { headers });
  }

  disableRulebook(id: number, filter: string): Observable<RegulationCheckboxReturnModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<RegulationCheckboxReturnModel>(`${environment.config.baseAppURL}/GDPR/DisableRulebook?id=` + id + '&filter=' + filter, { headers });
  }

  getCurrentUserRole(id: number): Observable<Role> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Role>(`${environment.config.baseAppURL}/Impact/GetRoleInfo?id=` + id, { headers });
  }

  updateRulebookById(rulebookId: number): Observable<RegulationModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<RegulationModel>(`${environment.config.baseAppURL}/GDPR/UpdateRulebookById?id=` + rulebookId, { headers });
  }

  getDateRange(library: string, rulebook: string): Observable<DateRangeModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', library + ';' + rulebook);
    return this.http.get<DateRangeModel>(`${environment.config.baseAppURL}/GDPR/GetRulebookDateRange`, { headers });
  }

  getRuleTreeData(filters: RulebookFilterModel): Observable<Array<RuleTreeDataModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<Array<RuleTreeDataModel>>(`${environment.config.baseAppURL}/GDPR/GetRuleTreeData`, filters, { headers });
  }

  getRulebookPolicies(searchStr: string): Observable<Array<Policies>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<Policies>>(`${environment.config.baseAppURL}/GDPR/GetPolicies?searchStr=` + searchStr, { headers });
  }

  getKeywordData(obj: KeywordModal): Observable<KeywordDataList> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(obj));
    // tslint:disable-next-line:max-line-length
    return this.http.get<KeywordDataList>(`${environment.config.baseAppURL}/GDPR/GetKeywordData`, { headers });
  }

  getHighlightedData(obj: KeywordModal): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(obj));
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/GetTextHighlightedData`, { headers });
  }

  saveRuleAnalyticData(obj: RuleAnalyticData): Observable<KeywordDataList> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<KeywordDataList>(`${environment.config.baseAppURL}/GDPR/SaveRuleAnalytic`, obj, { headers });
  }

  getRuleAnalyticList(ids: Array<number>): Observable<Array<RuleAnalytic>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(ids));
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<RuleAnalytic>>(`${environment.config.baseAppURL}/GDPR/GetRuleAnalytics`, { headers });
  }

  removeRuleAnalytic(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/DeleteRuleAnalytic?id=` + id, { headers });
  }

  duplicateRuleAnalytic(obj: RuleAnalytic): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/CopyRuleAnalytic`, obj, { headers });
  }

  compareDescriptionData(id: number): Observable<CompareItemModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<CompareItemModel>(`${environment.config.baseAppURL}/GDPR/CompareParentChildData?id=` + id, { headers });
  }
  moveToBulkImpactAssessment(mergeImpactDto: BulkInsertModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/BulkMoveToImpactAssessment`, mergeImpactDto, { headers });
  }
  getLibraryName(type: LibraryType): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/GetLibraryName?type=` + type, { headers });
  }
  getRuleBookDD(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/GetRuleBookDD`, { headers });
  }
  saveLibraryName(reportTemplate: RulebookLibraryMenu): Observable<number> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/AddUpdateLibraryName`, reportTemplate, { headers });
  }
  deleteLibraryName(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/DeleteRulebookLibrary?id=` + id, { headers });
  }
  getNewRulebooks(filter: RulebookFilterModel | null, skipCount: number, totalCount: number): Observable<RulebookViewModel> {
    if (filter) {
      filter.SkipCount = skipCount;
      filter.TakeCount = totalCount;
    }
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));

    // tslint:disable-next-line:max-line-length
    return this.http.get<RulebookViewModel>(`${environment.config.baseAppURL}/GDPR/GetRulebooks`, { headers });
  }
  generateSummary(id: number, type: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/GenerateSummary?id=` + id + `&type=` + type, { headers });
  }
  getUsedRuleBookDD(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/GetUsedRuleBook`, { headers });
  }
  getSummary(id: number, type: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify({ "id": id, "type": type }));
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/GetSummary`, { headers });
  }
  setSummary(input: setSummaryDetails): Observable<Array<RulebookSummary>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Array<RulebookSummary>>(`${environment.config.baseAppURL}/GDPR/SetSummary`, input, { headers });
  }

  moveToImpactAssessment4(itemInfoDto: ItemInfoDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/MoveToImpactAssessment4`, itemInfoDto, { headers });
  }
  moveToImpactAssessment6(itemInfoDto: ItemInfoDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/MoveToImpactAssessment6`, itemInfoDto, { headers });
  }

  moveToBulkImpactAssessmentT4(mergeImpactDto: BulkInsertModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/BulkMoveToImpactAssessmentT4`, mergeImpactDto, { headers });
  }
  moveToBulkImpactAssessmentT6(mergeImpactDto: BulkInsertModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/BulkMoveToImpactAssessmentT6`, mergeImpactDto, { headers });
  }

  getReportingTemplateDetailsById(id: number): Observable<Array<ReportingTemplate>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Array<ReportingTemplate>>(`${environment.config.baseAppURL}/GDPR/GetReportingTemplateDetailsById?id=` + id, { headers });
  }
  getReportingTemplateLibraryDD(): Observable<Array<ReprtingTemplateList>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<ReprtingTemplateList>>(`${environment.config.baseAppURL}/GDPR/GetReportingTemplates`, { headers });
  }
  GetUsedReportingTemplate(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/GetUsedReportingTemplate`, { headers });
  }
  getRulebookDocumentControl(searchStr: string): Observable<Array<string>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<string>>(`${environment.config.baseAppURL}/GDPR/GetRulebookControls?searchStr=` + searchStr, { headers });
  }
  getRulebookDocumentControlSection(controlStr: string): Observable<Array<string>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<string>>(`${environment.config.baseAppURL}/GDPR/GetRulebookControlSection?controlStr=` + controlStr, { headers });
  }
  getRulebookDocumentControlSubSection(controlStr: string, sectionStr: string): Observable<Array<string>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<string>>(`${environment.config.baseAppURL}/GDPR/GetRulebookControlSubSection?controlStr=` + controlStr + `&sectionStr=` + sectionStr, { headers });
  }
  saveLinkedControlData(obj: LinkedControlData, id: number): Observable<Array<LinkedControlData>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<Array<LinkedControlData>>(`${environment.config.baseAppURL}/GDPR/SaveRuleLinkedControl?id=` + id, obj, { headers });
  }
  UpdateRuleLinkedControl(LinkedCotrolJsonData: any, id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/UpdateRuleLinkedControl?id=` + id + `&LinkedCotrolJsonData=` + LinkedCotrolJsonData, { headers });
  }
  //control Document Attachment
  UploadRulebookControlDocumentAttachmentFile(fileToUpload: File, ruleId: number, tableId: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', ruleId.toString() + ';' + tableId.toString());
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/UploadRulebookControlDocumentAttachmentFile`, formData, { headers });
  }

  // downloadEvidence(id: number): Observable<any> {
  //   let headers = new HttpHeaders();
  //   headers = headers.set('Content-Type', 'application/json; charset=utf-8')
  //     .set('request', id.toString());
  //   return this.http.get(`${environment.config.baseAppURL}/GDPR/DownloadEvidence`, { headers, responseType: 'blob' });
  // }

  RemoveControlDocumentAttachment(ruleId: number, tableId: number): Observable<Array<ControlDocument>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<ControlDocument>>(`${environment.config.baseAppURL}/GDPR/DeleteAttachmentAfterRulebookControlDeletion?ruleId=` + ruleId + `&tableId=` + tableId, { headers });
  }

  DeleteRulebookControlDocumentAttachmentFile(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/DeleteRulebookControlDocumentAttachmentFile?id=` + id, { headers });
  }
  GetRulebookAllControlDocumentAttachment(ruleId: number): Observable<Array<ControlDocument>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<ControlDocument>>(`${environment.config.baseAppURL}/GDPR/GetRulebookAllControlDocumentAttachment?ruleId=` + ruleId, { headers });
  }
  downloadRulebookControlDocument(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get(`${environment.config.baseAppURL}/GDPR/DownloadRulebookControlAttachment?id=` + id, { headers, responseType: 'blob' });
  }
  getSelfAssessmentAllDropdownList(): Observable<SelfAssessmentAllDropdownList> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentAllDropdownList>(`${environment.config.baseAppURL}/GDPR/GetSelfAssessmentAllDropdownList`, { headers });
  }
  copySelfAssessment(id: number, copyType: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/GDPR/CopySelfAssessment?id=` + id + `&copyType=` + copyType, { headers });
  }
  sABulkUpdate(bulkUpdate: BulkSelfUpdateModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/SABulkUpdate`, bulkUpdate, { headers });
  }
  rulebookOwnerBulkUpdate(bulkUpdate: BulkUpdateRule): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<string>(`${environment.config.baseAppURL}/GDPR/BulkUpdateRulebook`, bulkUpdate, { headers });
  }
  rulebookCheckBoxBulkUpdate(bulkUpdate: BulkCheckBoxRule): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<string>(`${environment.config.baseAppURL}/GDPR/BulkUpdateCheckRulebooks`, bulkUpdate, { headers });
  }
  getOldestDate(): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<string>(`${environment.config.baseAppURL}/GDPR/GetOldestDate`, { headers });
  }
  getSelfAssessmentTemplate(jurisdiction: number): Observable<number> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<number>(`${environment.config.baseAppURL}/GDPR/GetSelfAssessmentTemplateNo?jurisdiction=` + jurisdiction, { headers });
  }


  // *****Self Assessment Template2*****

  getSelfAssessmentT2Details(id: number): Observable<SelfAssessmentNew> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentNew>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSelfAssessmentDetailsT2?id=` + id, { headers });
  }
  getSelfAssessmentT2Documents(id: number): Observable<Array<SelfAssessmentDocumentModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<SelfAssessmentDocumentModel>>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSelfAssessmentT2Document?id=` + id, { headers });
  }
  GetSAT2DetailsHistory(id: number): Observable<SelfAssessmentT2DetailHistory> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentT2DetailHistory>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSAT2DetailsHistory?id=` + id, { headers });
  }
  GetSelfAssessmentT2DD(): Observable<SelfAssessmentT2DetailsDD> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentT2DetailsDD>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSelfAssessmentT2DD`, { headers });
  }
  UploadEvidenceT2(fileToUpload: File, fileType: FileType, assessmentId: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', fileType.toString() + ';' + assessmentId.toString());
    return this.http.post<any>(`${environment.config.baseAppURL}/SelfAssessmentT2/UploadEvidenceFileT2`, formData, { headers });
  }
  deleteSelfAssessmentT2Document(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/SelfAssessmentT2/DeleteSelfAssessmentT2Document?id=` + id, { headers });
  }
  downloadEvidenceT2(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', id.toString());
    return this.http.get(`${environment.config.baseAppURL}/SelfAssessmentT2/DownloadEvidenceT2`, { headers, responseType: 'blob' });
  }
  getVersionHistoryT2(filter: VersionHistoryFilter): Observable<VersionHistoryViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<VersionHistoryViewModel>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetVersionHistoryT2`, { headers });
  }
  updateSelfAssessmentT2(selfAssessment: UpdateSelfAssessmentT2Model, url: string): Observable<SelfAssessmentNew> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', url);
    return this.http.post<SelfAssessmentNew>(`${environment.config.baseAppURL}/SelfAssessmentT2/UpdateSelfAssessmentT2`, selfAssessment, { headers });
  }
  downloadSAReportT2(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get(`${environment.config.baseAppURL}/SelfAssessmentT2/DownloadReportT2`, { headers, responseType: 'blob' });
  }
  downloadSAReportT3(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get(`${environment.config.baseAppURL}/SelfAssesmentT3/DownloadReportT3`, { headers, responseType: 'blob' });
  }
  getOldestDateT2(): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<string>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetOldestDateT2`, { headers });
  }
  getSelfAssessmentT2VersionDetails(id: number): Observable<SelfAssessmentT2VersionModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentT2VersionModel>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSelfAssessmentT2VersionDetails?id=` + id, { headers });
  }
  sABulkUpdateT2(bulkUpdate: BulkSelfUpdateModelT2): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/SelfAssessmentT2/SABulkUpdateT2`, bulkUpdate, { headers });
  }
  copySelfAssessmentT2(id: number, copyType: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/SelfAssessmentT2/CopySelfAssessmentT2?id=` + id + `&copyType=` + copyType, { headers });
  }
  addSelfAssessmentT2(itemInfoDto: ItemInfoDto): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<string>(`${environment.config.baseAppURL}/SelfAssessmentT2/AddSelfAssessmentT2`, itemInfoDto, { headers });
  }
  getSelfAssessmentT2AllDropdownList(): Observable<SelfAssessmentT2AllDropdownList> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentT2AllDropdownList>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSelfAssessmentT2AllDropdownList`, { headers });
  }
  getSelfAssessmentT2(filter: SelfAssessmentT2Filter): Observable<SelfAssessmentT2ViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    return this.http.get<SelfAssessmentT2ViewModel>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSelfAssessmentT2`, { headers });
  }
  getSelfAssessmentT2Gaps(filter: SelfAssessmentT2Filter): Observable<SelfAssessmentT2GapModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentT2GapModel>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSelfAssessmentT2Gaps`, { headers });
  }
  getSelfAssessmentT2Enhancements(filter: SelfAssessmentT2Filter): Observable<SelfAssessmentT2EnhancementModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentT2EnhancementModel>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSelfAssessmentT2Enhancements`, { headers });
  }
  getSelfAssessmentT2MasterFilters(): Observable<SelfAssessmentT2MasterFilter> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<SelfAssessmentT2MasterFilter>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSelfAssessmentT2MasterFilters`, { headers });
  }
  saveIdsInAssess(data: MergeAssess): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/AppendIdInImpactAssessment`, data, { headers });
  }
  updateSelfAssessmentCKT2(data: SelfAssessmentCkDataSaveModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/SelfAssessmentT2/UpdateSelfAssessmentCKT2`, data, { headers });
  }
  //For new section at view of Rulebook for Self Assessment Template 2
  getSelfAssessmentDetailsT2InRulebook(id: number): Observable<SelfAssessmentNew> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<SelfAssessmentNew>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSelfAssessmentDetailsT2InRulebook?id=` + id, { headers });
  }
  getSelfAssessmentStatusDetailsT2InRulebook(id: number): Observable<Array<SelfAssessmentNew>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Array<SelfAssessmentNew>>(`${environment.config.baseAppURL}/SelfAssessmentT2/GetSelfAssessmentStatusDetailsT2InRulebook?id=` + id, { headers });
  }

  //For Impact Assessment Template 5
  moveToImpactAssessment5(itemInfoDto: ItemInfoDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/MoveToImpactAssessment5`, itemInfoDto, { headers });
  }
  moveToBulkImpactAssessment5(mergeImpactDto: BulkInsertModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/BulkMoveToImpactAssessmentT5`, mergeImpactDto, { headers });
  }
  updateRulebookDescription(rulebookDto: updateRulebookModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/GDPR/UpdateRulebookDescription`, rulebookDto, { headers });
  }
  getSelfAssessmenT3StatusDetailsInRulebook(id: number): Observable<Array<SelfAssessmentNew>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Array<SelfAssessmentNew>>(`${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3StatusDetailsInRulebook?id=` + id, { headers });
  }

}
